import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../service/auth-service/auth-service.service';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrl: './user-info.component.scss'
})

export class UserInfoComponent implements OnInit {

  userid: string = "Unknown";
  organisationid: string = "";
  userlabel: string = "";
  org_type: string | null = "";
  org_name: string | null = "";
  isSessionExpired: boolean = false;

  constructor(private authService: AuthService
  ) { }
  
  ngOnInit(): void {

    this.authService.getUserLabelObservable().subscribe(label => {
      this.userid = label;
      this.userlabel = label;
    });

    this.authService.getOrganisationLabelObservable().subscribe(label => {
      this.organisationid = label;
      this.userlabel = this.userid + " (" + this.organisationid + ")";
    });

    //reason -> logout, sessionexpired
    this.authService.getLogoutCompleted().subscribe(
      (reason) => {
        this.organisationid = "";
        this.org_name = "";
        this.org_type = "";
        this.userlabel = this.userid;
        this.isSessionExpired = (reason === "sessionexpired");
      });

      this.showOrgInfo();
  }

  logoutConfirm() {
    this.authService.logOutConfirm();
  }

  switchOrganisationConfirm(): void {
    this.authService.switchOrganisationConfirm();
  }

  showOrgInfo(){
    this.org_type = this.authService.getOrgType();
    this.org_name = this.authService.getOrgName();
    this.organisationid = this.authService.getOrganisation();
    this.userlabel = this.userid + " (" + this.organisationid + ")";
  }

  
}

